import React, { useEffect } from "react";

import makeStyles from "@material-ui/core/styles/makeStyles";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import TestsRequests from "services/tests";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 20,
    marginBlock: "20px",
  },
  imageContainer: {
    width: "100px",
    height: "auto",
    borderRadius: "1rem",
  },
}));

const QuizAnswer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { id, quiz } = useParams();
  const { answer } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(TestsRequests.getAnswer(id, quiz));
  }, []);

  const getAnswer = (
    question,
    userOptionAnswer,
    userOptionsDifferenceAnswer,
    userOptionsSortingAnswer,
    userMaxRangeAnswer,
    userMinRangeAnswer,
    userOptionsConnectingAnswer,
    userFiles
  ) => {
    if (
      question.type === "multipleImageChoice" ||
      question.type === "multipleChoice"
    ) {
      return (
        <>
          <Typography color="primary">پاسخ کاربر :</Typography>
          <Typography style={{ marginBlock: "10px" }}>
            {question.type === "multipleChoice" ? (
              question[userOptionAnswer]
            ) : (
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <img
                  crossOrigin="anonymous"
                  className={classes.imageContainer}
                  src={`${baseUrl}file/get/${question[userOptionAnswer]}?thumbnail=true`}
                  alt={"image-preview"}
                />
              </Box>
            )}
          </Typography>
        </>
      );
    } else if (question.type === "difference") {
      const points = question.optionsDifference.map((pointString) => {
        const [x, y] = pointString.split("|").map(Number);
        return { x, y };
      });

      const diffPoints = userOptionsDifferenceAnswer.map((pointString) => {
        const [x, y] = pointString.split("|").map(Number);
        return { x, y };
      });

      return (
        <>
          <Typography
            color="primary"
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            کلید :
          </Typography>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            position={"relative"}
            maxWidth={"500px"}
            width={"100%"}
            marginX={"auto"}
            marginBottom={"20px"}
          >
            <img
              crossOrigin="anonymous"
              src={`${baseUrl}file/get/${question.optionsDifferenceImage1}?thumbnail=true`}
              alt={"image-preview"}
            />
            {points.map((point, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: `${point.y * 100}%`,
                  left: `${point.x * 100}%`,
                  transform: "translate(-50%, -50%)",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border: "2px solid red",
                }}
              />
            ))}
          </Box>
          <Typography
            color="primary"
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            پاسخ کاربر :
          </Typography>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            position={"relative"}
            maxWidth={"500px"}
            width={"100%"}
            marginX={"auto"}
            marginBottom={"20px"}
          >
            <img
              crossOrigin="anonymous"
              src={`${baseUrl}file/get/${question.optionsDifferenceImage2}?thumbnail=true`}
              alt={"image-preview"}
            />
            {diffPoints.map((point, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: `${point.y * 100}%`,
                  left: `${point.x * 100}%`,
                  transform: "translate(-50%, -50%)",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border: "2px solid red",
                }}
              />
            ))}
          </Box>
        </>
      );
    } else if (question.type === "sorting") {
      return (
        <Box>
          <Typography color="primary" style={{ marginBottom: "10px" }}>
            کلید :
          </Typography>
          <Typography>{question.optionsSorting.join(" | ")}</Typography>
          <Typography color="primary" style={{ marginBlock: "10px" }}>
            پاسخ کاربر :
          </Typography>
          <Typography style={{ marginBottom: "10px" }}>
            {userOptionsSortingAnswer.join(" | ")}
          </Typography>
        </Box>
      );
    } else if (question.type === "puzzle") {
      return (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          maxWidth={"500px"}
          width={"100%"}
          marginX={"auto"}
          marginBottom={"20px"}
        >
          <img
            crossOrigin="anonymous"
            src={`${baseUrl}file/get/${question.puzzleSource}?thumbnail=true`}
            alt={"image-preview"}
          />
        </Box>
      );
    } else if (question.type === "range") {
      return (
        <Box>
          <Typography color="primary" style={{ marginBottom: "10px" }}>
            کلید 1 :
          </Typography>
          <Typography>{question.minRangeAnswer}</Typography>
          <Typography color="primary" style={{ marginBlock: "10px" }}>
            کلید 2 :
          </Typography>
          <Typography>{question.maxRangeAnswer}</Typography>
          <Typography color="primary" style={{ marginBlock: "10px" }}>
            پاسخ کاربر 1:
          </Typography>
          <Typography style={{ marginBottom: "10px" }}>
            {userMaxRangeAnswer}
          </Typography>
          <Typography color="primary" style={{ marginBlock: "10px" }}>
            پاسخ کاربر 2:
          </Typography>
          <Typography style={{ marginBottom: "10px" }}>
            {userMinRangeAnswer}
          </Typography>
        </Box>
      );
    } else if (question.type === "connecting") {
      const transformedAnswer = question.optionsConnecting.map((item) => {
        const [rightSide, leftSide] = item.split("|");
        return { rightSide, leftSide };
      });
      const transformeduserAnswer = userOptionsConnectingAnswer.map((item) => {
        const [rightSide, leftSide] = item.split("|");
        return { rightSide, leftSide };
      });
      return (
        <>
          <Box marginBottom={"10px"}>
            <Typography color="primary">کلید :</Typography>
            <table
              border="1"
              style={{ width: "50%", margin: "20px auto", textAlign: "center" }}
            >
              <thead>
                <tr>
                  <th>سمت راست</th>
                  <th>سمت چپ</th>
                </tr>
              </thead>
              <tbody>
                {transformedAnswer.map((item, index) => (
                  <tr key={index}>
                    <td>{item.rightSide}</td>
                    <td>{item.leftSide}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
          <Box marginBottom={"10px"}>
            <Typography color="primary">پاسخ کاربر :</Typography>
            <table
              border="1"
              style={{ width: "50%", margin: "20px auto", textAlign: "center" }}
            >
              <thead>
                <tr>
                  <th>سمت راست</th>
                  <th>سمت چپ</th>
                </tr>
              </thead>
              <tbody>
                {transformeduserAnswer.map((item, index) => (
                  <tr key={index}>
                    <td>{item.rightSide}</td>
                    <td>{item.leftSide}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </>
      );
    } else if (question.type === "file") {
      return (
        <Box>
          {userFiles.map((item, index) => (
            <Typography
              color="primary"
              style={{ textDecoration: "underline", cursor: "pointer" }}
              key={index}
              onClick={() => {
                const link = document.createElement("a");
                link.href = `${baseUrl}file/get/${item}`;
                link.setAttribute("download", item.split("/").pop());
                link.setAttribute("target", "_blank");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      );
    }
  };

  return answer.length !== 0 ? (
    answer.map((item) => {
      return (
        <CmtCard className={classes.cardRoot}>
          <CmtCardContent className={classes.cardContentRoot}>
            <Typography>{item.questionId.title}</Typography>
            <hr style={{ marginBlock: "10px" }} />
            {getAnswer(
              item.questionId,
              item.userOptionAnswer,
              item.userOptionsDifferenceAnswer,
              item.userOptionsSortingAnswer,
              item.userMaxRangeAnswer,
              item.userMinRangeAnswer,
              item.userOptionsConnectingAnswer,
              item.userFiles
            )}
            <Typography color="primary">پاسخ صحیح :</Typography>
            <Typography style={{ marginBlock: "10px" }}>
              {item.rightAnswer ? (
                <CheckIcon color="primary" />
              ) : (
                <ClearIcon color="error" />
              )}
            </Typography>
          </CmtCardContent>
        </CmtCard>
      );
    })
  ) : (
    <Typography>موردی برای نمایش وجود ندارد.</Typography>
  );
};

export default QuizAnswer;
